import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: 'rc4', isCompression: false });

export const setSession = (key, value) => {
  ls.set(key, value);
};

export const getSession = (key) => {
  return ls.get(key);
};


export const setSessionJSON = (key, value) => {
  ls.set(key, JSON.stringify(value));
};

export const getSessionJSON = (key) => {
  return ls.get(key)?JSON.parse(ls.get(key)): null;
};
